module.exports = __webpack_public_path__ + "img/1.d2066844.jpg";